import React from "react";
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';
import hero1 from '../../images/slider/fireSlide.mp4';
import candles from '../../images/slider/candles of hearts.mp4';
import hero2 from '../../images/slider/slide-6.jpg';

const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const Hero2 = () => {
    return (
        <section className="hero-slider hero-style-2">
            <Swiper
                modules={[Navigation, A11y]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={1800}
                parallax={true}
                navigation
            >
                {/* First Slide with Video */}
                <SwiperSlide>
                    <div className="slide-inner slide-bg-video" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '100vh', position: 'relative', textAlign: 'center', color: '#fff' }}>
                        <video autoPlay loop muted playsInline className="background-video" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}>
                            <source src={hero1} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <div style={{ position: 'relative', zIndex: 1 }}>
                            <div data-swiper-parallax="300" className="slide-title">
                                <h2 style={{color: "#ffffff"}}>Love of Hearts Foundation Inc.</h2>
                            </div>
                            <div data-swiper-parallax="400" className="slide-text">
                                <h3 style={{
                                    color: "#ffffff",
                                    backgroundColor: "rgba(115, 30, 200, 0.7)", // transparent purple
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    display: "inline-block"
                                }}>
                                    Impacting Lives Through Love!
                                </h3>
                            </div>
                            <div data-swiper-parallax="500" className="slide-btns">
                                <Link onClick={ClickHandler} to="/" className="theme-btn-s5" style={{
                                    color: "#e10303",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent black
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    display: "inline-block"
                                }}>
                                    Donate Now <i className="fi flaticon-heart-1"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                {/* Second Slide with Image */}
                <SwiperSlide>
                    <div className="slide-inner slide-bg-video" style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        height: '100vh',
                        position: 'relative',
                        textAlign: 'center',
                        color: '#fff'
                    }}>
                        <video autoPlay loop muted playsInline className="background-video" style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            zIndex: 0
                        }}>
                            <source src={candles} type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>
                        <div style={{position: 'relative', zIndex: 1}}>
                            <div data-swiper-parallax="300" className="slide-title">
                                <h2 style={{color: "#ffffff"}}>Love of Hearts Foundation Inc.</h2>
                            </div>
                            <div data-swiper-parallax="400" className="slide-text">
                                <h3 className="theme-btn-s5" style={{
                                    color: "#ffffff",
                                    backgroundColor: "rgba(115, 30, 200, 0.7)", // transparent purple
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    display: "inline-block"
                                }}>
                                    Bridging the gap for dreams to become reality!
                                </h3>
                            </div>
                            <div data-swiper-parallax="500" className="slide-btns">
                                <Link onClick={ClickHandler} to="/" className="theme-btn-s2"  className="theme-btn-s5" style={{
                                    color: "#e10303",
                                    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent black
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    display: "inline-block"
                                }}>
                                    Donate Now <i className="fi flaticon-heart-1"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </section>
    );
};

export default Hero2;
